// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/** Memory stick with a plus — used for creating firmware versions. */
export function MemoryStickPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 12v-2" />
      <path d="M12 18v-2" />
      <path d="M13.5 16H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5.5" />
      <path d="M16 12v-2" />
      <path d="M16 19h6" />
      <path d="M19 16v6" />
      <path d="M2 11h1.5" />
      <path d="M20.5 11H22" />
      <path d="M4 18v-2" />
      <path d="M8 12v-2" />
      <path d="M8 18v-2" />
    </svg>
  );
}
